import React, { useEffect, useState, useMemo } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Circle } from 'react-leaflet';
// import MarkerClusterGroup from 'react-leaflet-cluster';
// import MarkerClusterGroup from '@changey/react-leaflet-markercluster';
import MarkerClusterGroup from 'react-leaflet-cluster';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';


import { alunos_geo } from '../../services/api';

// --- CONFIGURAÇÃO DE CORES E UNIDADES ---
// DICA: Em produção, você pode trazer isso do banco de dados também.


export const CORES_UNIDADES = {
    1: "#FF0000", // Vermelho
    2: "#0000FF", // Azul
    3: "#008000", // Verde
    4: "#000000", // preto
    5: "#800080", // Roxo
    6: "#FFA500", // Laranja
    7: "#00CED1", // Turquesa
    8: "#FF1493", // Rosa Choque
    9: "#8B4513", // Marrom
    10: "#708090", // Cinza Ardósia
    11: "#000080", // Azul Marinho
    12: "#DC143C", // Carmesim
    13: "#f7b7ff", // Rosa Claro
    14: "#708090",  // Cinza Ardósia
    15: "#4B0082", // Índigo
    16: "#00FF7F", // Verde Primavera
    17: "#FF4500", // Laranja Vermelho
    // Adicione mais se necessário ou use um fallback
};

const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', '', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']

// https://maps.google.com/maps?ll=-23.018347,-43.472943&z=19&t=m&hl=pt-BR&gl=US&mapclient=apiv3&cid=7556684560299615482
const UNIDADES_CONFIG = [
    { id: "01", nome: "BENTO RIBEIRO", lat: -22.866478, lng: -43.362688, cor: "#FF0000" },
    { id: "02", nome: "MADUREIRA", lat: -22.875417, lng: -43.340733, cor: "#0000FF" },
    { id: "03", nome: "SANTA CRUZ", lat: -22.924783, lng: -43.681378, cor: "#008000" },
    { id: "04", nome: "CASCADURA", lat: -22.880717, lng: -43.32306, cor: "#000000" },
    { id: "05", nome: "TAQUARA", lat: -22.91823, lng: -43.388325, cor: "#800080" },
    { id: "06", nome: "NILOPOLIS", lat: -22.806507, lng: -43.415278, cor: "#FFA500" },
    { id: "09", nome: "SEROPÉDICA", lat: -22.84092, lng: -43.710647, cor: "#00CED1" },
    { id: "10", nome: "BARRA DA TIJUCA", lat: -23.008326, lng: -43.316027, cor: "#FF1493" },
    { id: "11", nome: "CAMPO GRANDE", lat: -22.918895, lng: -43.551892, cor: "#8B4513" },
    // { id: "12", nome: "CENTRO DE EXCELÊNCIA", lat: -22.906, lng: -43.172, cor: "#708090" },
    { id: "13", nome: "MANGUEIRA", lat: -22.902593, lng: -43.242589, cor: "#f7b7ff" },
    { id: "14", nome: "MARICÁ", lat: -22.911717, lng: -42.820952, cor: "#32CD32" },
    { id: "15", nome: "ILHA DO GOVERNADOR", lat: -22.817818, lng: -43.199021, cor: "#FFD700" },
    { id: "16", nome: "FREGUESIA", lat: -22.936755, lng: -43.336062, cor: "#708090" },
    { id: "17", nome: "RECREIO DOS BANDEIRANTES", lat: -23.018347, lng: -43.472943, cor: "#00FF7F" },


];

// Mapeamento rápido de ID -> Cor para os alunos
const MAPA_CORES = UNIDADES_CONFIG.reduce((acc, uni) => {
    acc[uni.id] = uni.cor;
    return acc;
}, {});

// --- ÍCONES ---

// 1. Ícone da ESCOLA (Fixo e maior)
const schoolIcon = new L.Icon({
    iconUrl: 'https://cdn-icons-png.flaticon.com/512/2231/2231649.png', // Ícone de prédio escolar
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [0, -40]
});

// 2. Gerador de Ícone do ALUNO (SVG Dinâmico)
const createStudentIcon = (unidadeId) => {
    const cor = MAPA_CORES[unidadeId] || '#333'; // Cor padrão cinza se não achar ID

    // SVG de um pino simples preenchido com a cor da unidade
    const svgHtml = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30">
      <path fill="${cor}" stroke="white" stroke-width="1.5" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
      <circle cx="12" cy="9" r="2.5" fill="white"/>
    </svg>
  `;

    return new L.DivIcon({
        className: 'custom-marker-aluno', // Classe CSS definida acima
        html: svgHtml,
        iconSize: [30, 42],
        iconAnchor: [15, 42], // A ponta do pino
        popupAnchor: [0, -45]
    });
};

const criarIconeClusterCustomizado = (cluster) => {
    // Pega a quantidade de alunos dentro deste grupo
    const quantidade = cluster.getChildCount();

    // Define qual classe CSS usar baseado na quantidade
    let classeTamanhoCor = 'cluster-pequeno';
    let tamanhoIcone = 40;

    if (quantidade > 200) {
        classeTamanhoCor = 'cluster-grande';
        tamanhoIcone = 60;
    } else if (quantidade > 50) {
        classeTamanhoCor = 'cluster-medio';
        tamanhoIcone = 50;
    }

    // Retorna o ícone HTML customizado
    return L.divIcon({
        html: `<div class="custom-cluster-icon ${classeTamanhoCor}">${quantidade}</div>`,
        className: 'custom-cluster-wrapper', // Limpa o estilo padrão
        iconSize: L.point(tamanhoIcone, tamanhoIcone, true), // Centraliza o ícone corretamente
    });
};

const MapaSistema = () => {
    const [alunos, setAlunos] = useState([]);
    const [loading, setLoading] = useState(true);

    // Estado para controlar quais unidades estão visíveis (Filtro)
    // Inicialmente todas estão visíveis (true)
    const [visibilidade, setVisibilidade] = useState(
        UNIDADES_CONFIG.reduce((acc, uni) => ({ ...acc, [uni.id]: true }), {})
    );

    useEffect(() => {
        // Busca dados da API
        const fetchAlunos = async () => {
            try {
                //        const response = await fetch('http://localhost:3000/api/mapa-alunos');
                const response = await alunos_geo();
                const data = response; // Assumindo que a API já retorna os dados formatados

                // Garante que lat/lng sejam números
                const dadosFormatados = data.map(aluno => ({
                    ...aluno,
                    latitude: parseFloat(aluno.latitude),
                    longitude: parseFloat(aluno.longitude),
                    precisao: aluno.precisao === 'EXATA' ? 'ALTA' : aluno.precisao === 'RUA_SEM_NUMERO' ? 'MEDIA' : aluno.precisao === 'BAIRRO' ? 'BAIXA' : aluno.precisao
                }));

                setAlunos(dadosFormatados);
            } catch (error) {
                console.error("Erro ao carregar alunos:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchAlunos();
    }, []);

    // Filtra os alunos baseado na seleção da legenda
    // O useMemo evita reprocessar 11 mil itens a cada render desnecessário
    const alunosFiltrados = useMemo(() => {
        return alunos.filter(a => visibilidade[a.unidade_id]);
    }, [alunos, visibilidade]);

    // Função para alternar visibilidade na legenda
    const toggleVisibilidade = (id) => {
        setVisibilidade(prev => ({ ...prev, [id]: !prev[id] }));
    };

    return (
        <div style={{ position: 'relative', height: '100vh', width: '100%' }}>

            {loading && <div style={{ position: 'absolute', zIndex: 2000, top: '50%', left: '50%' }}>Carregando Mapa...</div>}

            <MapContainer
                // center={[-22.9068, -43.1729]}
                center={[-22.866478, -43.362688]} //Bento Ribeiro
                zoom={12}
                scrollWheelZoom={false} // <--- AQUI: Trava o scroll do mouse
                zoomControl={true}     // <--- AQUI: Esconde os botões padrão
                style={{ height: "100%", width: "100%" }}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/">OSM</a>'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                {/* --- CAMADA 1: UNIDADES E RAIOS DE COBERTURA --- */}
                {UNIDADES_CONFIG.map((uni) => (
                    visibilidade[uni.id] && (
                        <React.Fragment key={`uni-${uni.id}`}>
                            <Circle
                                center={[uni.lat, uni.lng]}
                                radius={2000} // 2km de raio
                                pathOptions={{ color: uni.cor, fillColor: uni.cor, fillOpacity: 0.15, weight: 1 }}
                            />
                            <Marker position={[uni.lat, uni.lng]} icon={schoolIcon}>
                                <Popup>
                                    <strong>{uni.nome}</strong><br />
                                    Total Alunos na Rede: {alunos.filter(a => a.unidade_id === uni.id).length}
                                </Popup>
                            </Marker>
                        </React.Fragment>
                    )
                ))}

                {/* --- CAMADA 2: ALUNOS (CLUSTERIZADOS) --- */}
                <MarkerClusterGroup
                    chunkedLoading // Essencial para performance com 11k pontos
                    // 1. Em qual zoom os grupos somem e viram PINS reais?
                    // (1 = Mundo inteiro, 18 = Porta da casa). 
                    // 15 ou 16 é ideal para nível de bairro/rua.
                    disableClusteringAtZoom={14}


                    // 2. Resolve o problema de irmãos/vizinhos no mesmo prédio
                    // Ao clicar num grupo no zoom máximo, eles abrem em espiral.
                    spiderfyOnMaxZoom={true}

                    // 3. Define quão "agressivo" é o agrupamento (em pixels)
                    // Padrão é 80. Diminuir para 40 faz aparecerem mais bolinhas pequenas
                    // e menos bolinhas gigantes.
                    maxClusterRadius={50}
                    showCoverageOnHover={false} // UX mais limpa
                    iconCreateFunction={criarIconeClusterCustomizado} // Ícones customizados para os clusters
                >
                    {alunosFiltrados.map((aluno) => (
                        <Marker
                            key={aluno.matricula}
                            position={[aluno.latitude, aluno.longitude]}
                            icon={createStudentIcon(aluno.unidade_id)}
                        >
                            <Popup>
                                <strong>Matrícula:</strong> {aluno.matricula}<br />
                                {/* <strong>Unidade ID:</strong> {aluno.unidade_id}<br /> */}
                                <span style={{ color: MAPA_CORES[aluno.unidade_id] }}>
                                    ● Aluno de {unidades[parseInt(aluno.unidade_id)]} <br />
                                    ● Precisão  {aluno.precisao}
                                </span>
                            </Popup>
                        </Marker>
                    ))}
                </MarkerClusterGroup>

            </MapContainer>

            {/* --- CAMADA 3: LEGENDA FLUTUANTE --- */}
            <div className="mapa-legenda">
                <h4 style={{ margin: '0 0 10px 0', fontSize: '14px' }}>Filtrar Unidades</h4>
                {UNIDADES_CONFIG.map(uni => (
                    <div
                        key={uni.id}
                        className="legenda-item"
                        onClick={() => toggleVisibilidade(uni.id)}
                        style={{ opacity: visibilidade[uni.id] ? 1 : 0.4 }} // Efeito visual de desabilitado
                    >
                        <div className="legenda-cor" style={{ backgroundColor: uni.cor }}></div>
                        <span style={{ fontSize: '12px' }}>{uni.nome}</span>
                    </div>
                ))}
            </div>

        </div>
    );
};

export default MapaSistema;